// @ts-nocheck
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ArrowLeft, Copy } from "lucide-react";
import CreateEventForm from "@/components/admin-dashboard/CreateEventForm";
import { CloneEventDialog } from "@/components/admin-dashboard/CloneEventDialog";

const CreateEventPage: React.FC = () => {
  const navigate = useNavigate();
  const [cloneOpen, setCloneOpen] = useState(false);

  const handleBackToEvents = () => {
    navigate('/modular-dashboard');
  };

  const handleEventCreated = () => {
    // Navigate back to new modular events dashboard after successful creation
    navigate('/modular-dashboard');
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Button
          variant="ghost"
          size="sm"
          onClick={handleBackToEvents}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Events
        </Button>
        <div>
          <h1 className="text-2xl font-bold font-heading">Create New Event</h1>
          <p className="text-muted-foreground">Fill out the form below to create a new event</p>
        </div>
      </div>

      {/* Clone callout */}
      <Card className="bg-muted/40 border-dashed">
        <CardContent className="flex items-center justify-between p-4">
          <div>
            <p className="text-sm font-medium">Already have a similar event?</p>
            <p className="text-xs text-muted-foreground">Clone its configuration to save time.</p>
          </div>
          <Button variant="outline" size="sm" onClick={() => setCloneOpen(true)} className="flex items-center gap-2">
            <Copy className="h-4 w-4" />
            Clone from previous event
          </Button>
        </CardContent>
      </Card>

      <CloneEventDialog open={cloneOpen} onOpenChange={setCloneOpen} />

      <CreateEventForm onEventCreated={handleEventCreated} />
    </div>
  );
};

export default CreateEventPage;
